import React from 'react';

import {
    ChartBarResume,
    GraphBarResult,
    GraphBarRecomended,
    GraphBarResultP,

} from './styles'

type Props = {
    result?: number;
    recomended?: number;
    margin?: number;
    displayRecomended?: 'flex' | 'none';
}

const ChartBarTotal = ({ result, recomended = 0, margin, displayRecomended = 'flex' } : Props) => {
    return (
        <ChartBarResume>
            <GraphBarResult result={result}>
                <GraphBarResultP margin={margin}> {result? result: 0}% </GraphBarResultP>
            </GraphBarResult>
            <GraphBarRecomended
                displayRecomended={displayRecomended}
                recomended={recomended}><p>{recomended}%</p>
            </GraphBarRecomended>
        </ChartBarResume>
    );
};

export default ChartBarTotal;
